<template>
    <div class="d-flex col-sm justify-content-center">
        <div class="container-fluid">
            <div class="row">
                <div class="col"><!-- col-xl-8 -->
                    <pokemon-adder />
                </div>
            </div>
            <div class="row">
                <div class="col"><!-- col-xl-2 -->

                </div>
                <div class="col"><!-- col-xl-2 -->

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PokemonAdder from "./components/pokemon/PokemonAdder";
    export default {
        name: "Pokemon",
        components: {
            PokemonAdder,
        }
    }
</script>

<style scoped>

</style>